module.exports = __webpack_public_path__ + "static/media/speaker.d3b8b0f3.svg";